module.exports = "{{#each comments}}\n<li class=\"comment-item\">\n    <div class=\"avatar\">\n        <img src=\"https://avatars1.githubusercontent.com/u/{{avatar}}\" alt=\"\">\n    </div>\n    <div class=\"comment-detail\">\n        <div class=\"name\">{{name}}</div>\n        <div class=\"text\">{{text}}</div>\n        <div class=\"time\">{{rtime}}</div>\n    </div>\n</li>\n{{else}}\n<div class=\"none-comment\">\n    <i class=\"icon ios7-chatboxes-outline\"></i>\n    <p>{{t i18n=\"i18n.comment.empty_comment\"}}</p>\n</div>\n{{/each}}";


/*****************
 ** WEBPACK FOOTER
 ** ./src/modules/comment/comment.tpl.html
 ** module id = 35
 ** module chunks = 0
 **/